import { styled, Typography } from '@mui/material';
import { CustomBox } from '../layout.styles';

export const CustomSideBar = styled(CustomBox)(() => ({
    width: '25%',
    display: 'flex',
    flexDirection: 'column',
}));

export const CustomSideBarTitle = styled(Typography)(() => ({
    textAlign: 'center',
    fontSize: '30px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flexShrink: 0,
}));

export const CustomSideBarSubTitle = styled(Typography)(() => ({
    textAlign: 'center',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flexShrink: 0,
}));
